<script setup lang="ts">

import ExtensionNavigationService from "@/extension/services/ExtensionNavigationService";
import {ExtensionGrid} from "@/extension/components/extension-grid";
import Extension from "@/core/interfaces/extension/Extension";
import Icon from "@/core/components/icon/Icon.vue";
import {useRoute} from "vue-router";
import {Inbox} from "@lucide/vue";

defineProps<{
    extensions: Extension[];
}>();

const route = useRoute();
</script>

<template>
  <div class="relative">
    <div class="relative bg-white rounded-3xl shadow-xl p-8 border border-gray-100">
      <div class="mb-8 text-center">
        <div class="inline-flex items-center justify-center w-16 h-16 gradient rounded-2xl mb-4">
          <Icon name="mdi-view-grid" class="w-8 h-8 text-white" />
        </div>
        <h2 class="text-3xl font-bold text-gray-900 mb-3">
          Modules Exclusifs
        </h2>
        <p class="text-lg text-gray-600 max-w-2xl mx-auto">
          Profitez des outils et services spécialement sélectionnés par votre groupement pour optimiser votre activité pharmaceutique.
        </p>
        <div class="w-24 h-1 gradient rounded-full mx-auto mt-4" />
      </div>
      <div class="bg-gray-50 rounded-2xl p-6">
        <ExtensionGrid
          title=""
          :extensions="extensions"
          @extension-click="extension => ExtensionNavigationService.navigate(extension, $router, route)"
        />

        <div v-if="!extensions.length" class="text-center py-12">
          <div class="w-16 h-16 bg-gray-200 rounded-full mx-auto mb-4 flex items-center justify-center">
            <Inbox class="w-6 h-6 text-gray-400" />
          </div>
          <h3 class="text-lg font-semibold text-gray-900 mb-2">
            Aucun module disponible
          </h3>
          <p class="text-gray-600">
            Les modules de votre groupement seront bientôt disponibles.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
